<template>
  <div class="scrolling pa-2" :class="{ fillHeight: events.length == 0 }">
    <div class="fixedHeader">
      <SearchBar ref="searchBar" />
      <footer class="mb-3 ml-2" style="display: flex" v-if="returns > 0">
        <div class="mr-2 clickable" @click="emitter" v-if="mobileState"><v-icon color="primary">mdi-map</v-icon></div>
        <div class="mt-3" v-if="false">{{ returns }} events</div>
        <section class="stateObject ml-1 primary--text" color="primary" @click="toStats">
          <div>Confirmed: {{ dataGetStats.confirmed }}</div>
          <div>Deaths: {{ dataGetStats.deaths }}</div>
          <div>Recovered: {{ dataGetStats.recovered }}</div>
        </section>
        <v-btn icon class="ml-auto mt-auto mb-auto mr-2 white--text" color="primary" @click="toEvntlcom">
          <v-icon color="white">mdi-home</v-icon>
        </v-btn>
        <v-btn icon class="ml-1 mt-auto mb-auto mr-2 white--text" color="primary" @click="search"> <v-icon color="white">mdi-refresh</v-icon> </v-btn>
      </footer>
      <footer class="mb-3 ml-2" style="display: flex" v-else>
        <div class="mr-2 clickable" @click="emitter" v-if="mobileState"><v-icon color="primary">mdi-map</v-icon></div>
        <div class="mt-3" v-if="false">No more events</div>
        <section class="stateObject ml-1 primary--text" color="primary" @click="toStats">
          <div>Confirmed: {{ dataGetStats.confirmed }}</div>
          <div>Deaths: {{ dataGetStats.deaths }}</div>
          <div>Recovered: {{ dataGetStats.recovered }}</div>
        </section>
        <v-btn icon class="ml-auto mt-auto mb-auto mr-2 white--text" color="primary" @click="toEvntlcom">
          <v-icon color="white">mdi-home</v-icon>
        </v-btn>
        <v-btn icon class="ml-1 mt-auto mb-auto mr-2 white--text" color="primary" @click="search"> <v-icon color="white">mdi-refresh</v-icon> </v-btn>
      </footer>
      <v-divider />
    </div>
    <div class="fixedScroll">
      <v-list three-line dense>
        <EventList
          v-for="(event, index) in events"
          :key="event._id"
          :event="event"
          :index="index"
          v-show="events.length !== 0"
          @eventClickedOne="emitter"
        />
        <v-layout fill-height align-center justify-center column v-show="events.length == 0">
          <v-flex class="sideDrawer-empty-container">
            <p class="mt-4 mb-4">There are no events of this search criteria</p>
            <p>
              Use the search bar to look for events. <br />Click on <span> <v-icon>mdi-menu</v-icon> </span> to do advance search
            </p>
          </v-flex>
        </v-layout>
        <!-- <div class="sideDrawer-empty-container">
            <p>
              Use the search bar to look for events. <br />Click on <span> <v-icon>mdi-menu</v-icon> </span> to do advance search
            </p>
        </div>-->
        <v-layout fill-height align-space-around justify-center column v-show="events.length !== 0">
          <v-btn @click="checkIfItemsNeedToBeLoaded" color="primary" class="white--text" v-if="!eventsGetEndOfList">GetMore</v-btn>
          <div class="endOfList" v-else>You have reach the end of the list</div>
        </v-layout>
      </v-list>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/side-drawer/SearchBar';
import EventList from '@/components/side-drawer/EventList';
import { mapGetters } from 'vuex';

export default {
  name: 'SideDrawer',
  components: {
    SearchBar,
    EventList
  },
  computed: {
    ...mapGetters({
      returns: 'returns',
      events: 'events',
      mobileState: 'generalGetMobileState',
      eventsGetEndOfList: 'eventsGetEndOfList',
      dataGetStats: 'dataGetStats'
    })
  },
  methods: {
    checkIfItemsNeedToBeLoaded() {
      if (!this.isLoading) {
        this.$store.dispatch('eventsNextPage');
      }
    },
    emitter() {
      this.$emit('eventClickedTwo');
    },
    search() {
      this.$ga.event('send', {
        eventCategory: 'Events',
        eventAction: 'Refreshed events'
      });
      this.$refs.searchBar.submit(true);
    },
    toStats() {
      this.$router.push('/datatable');
    },
    toEvntlcom() {
      window.open('https://evntl.com/', '_blank');
    }
  }
};
</script>

<style scoped>
.scrolling {
  background-color: #eaeef7;
  color: #085280;
}
.fillHeight {
  height: 100%;
}
.clickable {
  cursor: pointer;
  margin-top: 1rem;
}
.endOfList {
  width: 100%;
  text-align: center;
  margin-top: 2rem;
}
.stateObject {
  font-size: 1rem;
  cursor: pointer;
}
.sideDrawer-empty-container {
  text-align: center;
}
/* .fixedHeader {
  position: absolute;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
} */
/* .fixedScroll {
  position: absolute;
  z-index: 2000;
  bottom: 0;
  right: 0;
  left: 0.5rem;
  top: 10rem;
} */
</style>
